import { useState } from 'react'
import useSWR from 'swr'
import { API_BASE_URL } from 'config/api'
import { fetcher, IError, ApiResponse, Meta } from 'utils/fetchers'

interface ProductRequest {
  id: string
  productName: string
  author: string
  vendor: string | null
  publisher: string
  translator: string
  fullName: string
  cellphone: string
  email: string
  isFulfilled: boolean
  productId: string | null
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  'product.id': string | null
  'product.title': string | null
}

interface PaginationOptions {
  page?: number
  per_page?: number
}

export function useFetchProductRequests(paginationOptions?: PaginationOptions) {
  const [page, setPage] = useState(paginationOptions?.page || 1)
  const [per_page, setPerPage] = useState(paginationOptions?.per_page || 20)

  const apiUrl = `${API_BASE_URL}/product-requests?page=${page}&per_page=${per_page}`

  const { data: response, error } = useSWR<
    ApiResponse<ProductRequest[]>,
    IError | null
  >(apiUrl, fetcher)

  // Extract data and meta from response
  const productRequests = response?.data || undefined
  const meta = response?.meta

  // Check for API-level errors
  const apiError = response && !response.success ? response.error : null
  const finalError = error || apiError

  const goToPage = (pageNum: number) => setPage(Math.max(1, pageNum))
  const setItemsPerPage = (count: number) => {
    setPerPage(Math.max(1, count))
    setPage(1) // Reset to first page when changing items per page
  }

  return {
    productRequests,
    isLoading: !finalError && !response,
    isError: !!finalError,
    error: finalError,
    meta: meta as Meta | undefined,
    pagination: {
      page,
      per_page,
      goToPage,
      setItemsPerPage,
    },
  }
}
